import Breadcrumb from "../../Component/Breadcrumb";

function SpecialInstruction() {
  return (
    <>
      <Breadcrumb>Policies / Special Instruction To Students</Breadcrumb>

      <div className="innersec ">
        <div className="container">
          <div className="col-lg-12">
            <h1>Special Instruction To Students</h1>
          </div>
          <div className="recommendations-section">
            <div className="recommendations-card shadow-sm  rounded-4 bg-white">
              <ol className="modern-list">
                <li>
                  In your dress and behaviour, keep a sense of self-respect.
                  Right behaviour is the expression of fine character and a good
                  personality.
                </li>
                <li>Be simple in your ways and words.</li>
                <li>Avoid using indecent language.</li>
                <li>
                  <strong>COURTESY BEGETS COURTESY.</strong> Use words like
                  “please”, “thank you”, “excuse me”, “sorry”, and “may I” more
                  often. If you have to criticize, do it constructively, not
                  destructively.
                </li>
                <li>
                  In all dealings with others, be polite and obliging. Always
                  try to be a good companion, to help others and hurt nobody.
                </li>
                <li>
                  Respect your elders and teachers — greet them with respect and
                  love whenever you meet them.
                </li>
                <li>Be polite and helpful to strangers visiting the school.</li>
                <li>
                  English is the medium of communication in the school premises.
                  Speak only in English during school hours.
                </li>
                <li>Before and after every class, stand up for prayer.</li>
                <li>
                  No exemption shall be given from school programs or functions.
                  Every student is expected to participate and co-operate in
                  cultural, sports, and other school activities.
                </li>
                <li>
                  Make good use of the library and reading room. Handle books
                  and periodicals carefully and keep them tidy.
                </li>
                <li>
                  Do not bring any literature unrelated to school curriculum to
                  school.
                </li>
                <li>
                  Keep the school premises clean and tidy — it is the duty of
                  every student.
                </li>
                <li>
                  Be friendly, courteous, and co-operative towards fellow
                  students. Avoid calling nicknames, spreading rumours, or any
                  disrespectful conduct.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default SpecialInstruction;
